import { type NowDataState } from 'types/redux'

const preloadedNowDataState: NowDataState | null = null

export default preloadedNowDataState
